module.exports = __webpack_public_path__ + "img/info-circle-w.f5397a18.svg";